"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _CmsMarketingBundlePriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/CmsMarketingBundlePriceDisplay"));

var _underscore = require("underscore");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  right: 14px;\n  top: 15px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 12px 20px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 16px;\n  font-weight: bold;\n  display: block;\n  margin-bottom: 4px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  max-width: 300px;\n  padding: 12px 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  transform: rotate(90deg);\n  padding: 0 20px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-image: linear-gradient(90deg, ", ", ", ");\n  cursor: pointer;\n\n  &&& {\n    padding: 10px 0;\n  }\n\n  transition: transform 0.6s ease;\n  transform: translateY(300px);\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: fixed;\n  bottom: 4px;\n  left: 16px;\n  z-index: 120;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var THROTTLE_WAIT = 100;

var StickyContainer = _styledComponents.default.div.withConfig({
  displayName: "CmsMarketingBundleFloatingAlert__StickyContainer",
  componentId: "uu0b42-0"
})(_templateObject());

var StyledCardWrapper = (0, _styledComponents.default)(_UICardWrapper.default).withConfig({
  displayName: "CmsMarketingBundleFloatingAlert__StyledCardWrapper",
  componentId: "uu0b42-1"
})(_templateObject2(), _colors.THUNDERDOME, _colors.CALYPSO, function (_ref) {
  var showAlert = _ref.showAlert;
  return showAlert && "transform: translateY(0px);";
});
var RotatedIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "CmsMarketingBundleFloatingAlert__RotatedIcon",
  componentId: "uu0b42-2"
})(_templateObject3());

var TextContainer = _styledComponents.default.div.withConfig({
  displayName: "CmsMarketingBundleFloatingAlert__TextContainer",
  componentId: "uu0b42-3"
})(_templateObject4(), _colors.OLAF);

var HeaderMessage = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "CmsMarketingBundleFloatingAlert__HeaderMessage",
  componentId: "uu0b42-4"
})(_templateObject5());

var PriceDisplayWrapper = _styledComponents.default.div.withConfig({
  displayName: "CmsMarketingBundleFloatingAlert__PriceDisplayWrapper",
  componentId: "uu0b42-5"
})(_templateObject6());

var StyledCloseButton = (0, _styledComponents.default)(_UICloseButton.default).withConfig({
  displayName: "CmsMarketingBundleFloatingAlert__StyledCloseButton",
  componentId: "uu0b42-6"
})(_templateObject7());

var FloatingScrollAlert =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FloatingScrollAlert, _React$Component);

  function FloatingScrollAlert() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FloatingScrollAlert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FloatingScrollAlert)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      shouldRenderComponent: false,
      showAlert: false,
      hasSeenTargetElement: false,
      mon332AlertDismissed: false
    };
    _this.onScroll = (0, _underscore.throttle)(function () {
      var _this$state = _this.state,
          shouldRenderComponent = _this$state.shouldRenderComponent,
          showAlert = _this$state.showAlert,
          hasSeenTargetElement = _this$state.hasSeenTargetElement; // Don't show alert again once user has already seen target

      if (hasSeenTargetElement) return; // Don't show alert until user scrolls down a little

      if (!shouldRenderComponent && _this._hasSeen20PercentOfPage()) {
        _this.allowAlertRender();
      } // Don't show alert while target is in view


      if (showAlert && _this._hasScrolledElementIntoView(_this.props.targetElement)) {
        _this.hideAlert();

        return;
      }

      if (!showAlert) _this.setState({
        showAlert: true
      });
    }, THROTTLE_WAIT);

    _this.allowAlertRender = function () {
      _this.setState({
        shouldRenderComponent: true
      });

      (0, _getUsageTracker.default)().track('scrollInteraction', {
        name: 'alert element',
        action: 'viewed'
      });
    };

    _this.hideAlert = function () {
      _this.setState({
        showAlert: false,
        hasSeenTargetElement: true
      });

      (0, _getUsageTracker.default)().track('scrollInteraction', {
        name: 'target element',
        action: 'viewed'
      });
    };

    _this._hasScrolledElementIntoView = function (element) {
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      var rect = element.getBoundingClientRect();
      var isElementInView = rect.top <= windowHeight - 200 && rect.top + rect.height >= 0;
      return isElementInView;
    };

    _this._hasSeen20PercentOfPage = function () {
      var scrollDepth = window.pageYOffset || document.documentElement.scrollTop;
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      var documentHeight = document.body.scrollHeight || document.documentElement.scrollHeight;
      var percentOfPageSeen = (scrollDepth + windowHeight) / documentHeight;
      return percentOfPageSeen >= 0.2;
    };

    _this.handleClick = function () {
      var scrollDestination = _this.props.targetElement.offsetTop - 180; // accommodate for nav/tabs

      window.scrollTo({
        top: scrollDestination,
        behavior: 'smooth'
      });
      (0, _getUsageTracker.default)().track('scrollInteraction', {
        name: 'alert element',
        action: 'clicked'
      });
    };

    return _this;
  }

  (0, _createClass2.default)(FloatingScrollAlert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.onScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isDismissable = this.props.mon332Param === 'dismissable';
      if (isDismissable && this.state.mon332AlertDismissed) return null;

      var onCloseClick = function onCloseClick() {
        _this2.setState({
          mon332AlertDismissed: true
        });

        (0, _getUsageTracker.default)().track('scrollInteraction', {
          name: 'alert element',
          action: 'closed'
        });
      };

      return _react.default.createElement(StickyContainer, null, _react.default.createElement(StyledCardWrapper, {
        showAlert: this.state.showAlert
      }, isDismissable && _react.default.createElement(StyledCloseButton, {
        onClick: onCloseClick,
        size: "medium"
      }), _react.default.createElement(_UIFlex.default, {
        onClick: this.handleClick
      }, _react.default.createElement(_UIFlex.default, {
        align: "center"
      }, _react.default.createElement(RotatedIcon, {
        name: "next",
        size: "medium",
        color: _colors.OLAF
      }), _react.default.createElement(TextContainer, null, _react.default.createElement(HeaderMessage, {
        message: "cmsHubMarketingStarterBundle.cta"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "cmsHubMarketingStarterBundle.description"
      }))), _react.default.createElement(PriceDisplayWrapper, null, _react.default.createElement(_CmsMarketingBundlePriceDisplay.default, {
        simplified: true
      })))));
    }
  }]);
  return FloatingScrollAlert;
}(_react.default.Component);

var _default = FloatingScrollAlert;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/CmsMarketingBundleFloatingAlert.js
// module id = 850
// module chunks = 5 6